// Legacy verification-id form was replaced with the unified Google sign-in.
// This route (/demo) now uses the same SigninForm so the experience is
// consistent everywhere. Wrapper kept so existing imports of <Login/> still work.
import React from "react";
import {SigninForm} from "../../molecules/SigninForm";

export default function Login() {
	return (
		<div className="BookingSteps" style={{
			boxShadow: "10px 10px 12px rgba(0,0,0,0.1)",
			padding: "20px",
			border: "1px solid lightgray",
			marginTop: "20px",
			borderRadius: "30px",
			backgroundColor: 'rgba(70, 95, 195, 0.71)'
		}}>
			<p style={{textAlign: 'left', marginTop: 0}}>
				<label style={{color: 'white', fontSize: 25, marginLeft: "30px", fontWeight: "bolder"}}>Sign in:</label>
			</p>
			<div style={{
				background: 'white',
				borderRadius: '20px',
				padding: '20px',
				margin: '0 30px'
			}}>
				<SigninForm onClose={() => {}}/>
			</div>
		</div>
	);
}
